import Vue from "vue";
import Vuex from "vuex";
import { cart } from "./cart";
import { movie } from "./movie";
Vue.use(Vuex);

/** */

/** */

export default new Vuex.Store({
  state: {},
  getters: {},
  mutations: {},
  actions: {},
  modules: {
    cart,
    movie,
  },
});
